import { render } from "./JobOfferDetails.vue?vue&type=template&id=b901f8d8&scoped=true"
import script from "./JobOfferDetails.vue?vue&type=script&lang=js"
export * from "./JobOfferDetails.vue?vue&type=script&lang=js"

import "./JobOfferDetails.vue?vue&type=style&index=0&id=b901f8d8&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b901f8d8"]])

export default __exports__